<template>
    <Transition name="loading-bar">
        <div v-if="loadingStore.isLoading" class="global-loading-bar">
            <div 
                class="loading-bar-progress" 
                :style="{ width: loadingStore.progress + '%' }"
            ></div>
        </div>
    </Transition>
</template>

<script>
import { useLoadingBarStore } from '@/stores/LoadingBarStore.js'

export default {
    name: 'GlobalLoadingBar',
    setup() {
        const loadingStore = useLoadingBarStore()
        return { loadingStore }
    }
}
</script>

<style scoped>
.global-loading-bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background-color: transparent;
    z-index: 9999;
    overflow: hidden;
}

.loading-bar-progress {
    height: 100%;
    background: linear-gradient(90deg, var(--main-color, #24a8b4) 0%, var(--accent-color, #006c88) 100%);
    transition: width 0.2s ease;
    box-shadow: 0 0 10px var(--main-color, #24a8b4);
}

/* Анимация появления/исчезновения */
.loading-bar-enter-active,
.loading-bar-leave-active {
    transition: opacity 0.3s ease;
}

.loading-bar-enter-from,
.loading-bar-leave-to {
    opacity: 0;
}
</style>
